import React from 'react'
import styles from './not_found_url.module.css'
import getStringsBasedLang from '../../strings/get_strings'
import { useNavigate } from 'react-router-dom';

export default function NotFoundUrl() {
    let navigate = useNavigate()
    const lang = localStorage.getItem('lang')
    return (
        <div className={`${styles.container} flex justify-center items-center`}>
            <div className='flex-col'>
                <div className="flex justify-center">
                    <img className={styles.error_number} src={require(`../../assets/icons/${lang === 'en' ? '404_en' : '404'}.svg`)} alt="404" />
                </div>
                <div className="flex flex-col items-center">
                    <span className={styles.text_top}>{getStringsBasedLang("general_notFound_title")}</span>
                    <span className={styles.text_bottom}>{getStringsBasedLang("general_notFound_subTitle")}</span>
                </div>
                <div className='flex justify-center mt-10 sm:mt-5 xs:mt-5'><button className='rounded-full text-white bg-gray-400 cursor-pointer px-3 py-2 border-0 w-24' onClick={() => navigate(-1)}>{getStringsBasedLang("general_back")}</button></div>
            </div>

        </div>
    )
}
